import { PlatformAdminApi } from 'src/services/GrpcService';

export class TokenResponseDto implements PlatformAdminApi.ITokenResponse {
  accessToken!: string;
  refreshToken!: string;
  expiresIn!: string;
}
